import {Reducer} from "redux";

import {IBannerTemplate, IBannerTemplateState,} from "./types";
import mergeWith from "lodash/mergeWith";
import merge from "lodash/merge"
import isArray from "lodash/isArray"

import {ActionType, getType} from "typesafe-actions";
import * as templateActions from "../template/actions";
import * as filesActions from "../template/files/actions";
import {defaultActive, defaultChildActive, defaultMasterActive} from "./defaults";

export type BannerTemplateAction = ActionType<typeof templateActions>;
export type BannerTemplateFilesAction = ActionType<typeof filesActions>;


const initialBannerTemplatesState: IBannerTemplateState = {
    bannerTemplates: {
        byId: {
        },
    },
    isLoading: false,
    isSaving: false,
    activeBannerTemplate: defaultActive,
    filter: {
        parentId: ""
    },
    activeFolders: {scss: {}, html: {}},
    isReloadingActiveFolders: false
};


const loadNewBannerTemplate = (value: IBannerTemplate, state: IBannerTemplateState) => {
    return {
        ...state.bannerTemplates,
        byId: {
            ...state.bannerTemplates.byId,
            [value.id]: value
        },
    }
};


export const bannerTemplatesReducer: Reducer<IBannerTemplateState, BannerTemplateAction | BannerTemplateFilesAction> = (
    state = initialBannerTemplatesState,
    action
) => {
    switch (action.type) {
        case getType(templateActions.fetchBannerTemplateByIdAsyncActions.request):
            return {
                ...state,
                isLoading: true
            };
        case getType(templateActions.fetchBannerTemplateByIdAsyncActions.success):
            return {
                ...state,
                isLoading: false,
                bannerTemplates: {
                    ...loadNewBannerTemplate(action.payload.bannerTemplate, state)
                },
                activeBannerTemplate: action.payload.bannerTemplate,
                activeMasterBannerTemplate: action.payload.masterBannerTemplate,
                activeFolders: {scss: {}, html: {}},
            };
        case getType(templateActions.saveBannerTemplateAsyncActions.request):
            return {
                ...state,
                isSaving: true
            };
        case getType(templateActions.saveBannerTemplateAsyncActions.success):
            return {
                ...state,
                isSaving: false,
                bannerTemplates: {
                    ...loadNewBannerTemplate(action.payload.bannerTemplate, state)
                },
                activeBannerTemplate: action.payload.bannerTemplate
            };
        case getType(templateActions.fetchBannerTemplatesAsyncActions.request):
            return {
                ...state,
                isLoading: true
            };
        case getType(templateActions.fetchBannerTemplatesAsyncActions.success):
            const templates = action.payload.bannerTemplates;
            return {
                ...state,
                isLoading: false,
                bannerTemplates: {
                    ...state.bannerTemplates,
                    byId: {
                        ...state.bannerTemplates.byId,
                        ...templates.byId,
                    },

                }
            };
        case getType(templateActions.deleteBannerTemplateAsyncActions.request):
            return {
                ...state,
                isLoading: true,
            };
        case getType(templateActions.deleteBannerTemplateAsyncActions.success):
            const {[action.payload.id]: removed, ...without} = state.bannerTemplates.byId;
            let active = state.activeBannerTemplate.id === action.payload.id ? defaultActive : state.activeBannerTemplate;

            return {
                ...state,
                isLoading: false,
                bannerTemplates: {
                    byId: without,
                },
                activeBannerTemplate: active,
            };
        case getType(templateActions.modifyingActiveBannerTemplateAction):
            // https://github.com/reduxjs/redux/issues/398 Merge is mutative.
            const activeBannerTemplate = mergeWith({}, state.activeBannerTemplate, action.payload.bannerTemplate, overWriteArrayCustomizer);
            return {
                ...state,
                activeBannerTemplate: activeBannerTemplate
            };
        case getType(templateActions.addingNewBannerTemplateAction):
            return {
                ...state,
                activeBannerTemplate: defaultActive
            };
        case getType(templateActions.linkBannerVariablesIdAsyncAction.success):
            return {
                ...state,
            };
        case getType(templateActions.toggleBannerTemplatesFilterAction):
            let parentId = state.filter.parentId;
            let newParentId = action.payload.filter.parentId;
            if (newParentId && parentId === newParentId) {
                newParentId = ""
            }
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload.filter,
                    parentId: newParentId
                }
            };
        case getType(templateActions.setMasterActiveBannerTemplateByIdAction):
            let activeMasterBannerTemplate = state.activeMasterBannerTemplate;
            if (state.bannerTemplates.byId[action.payload.id]) {
                activeMasterBannerTemplate = state.bannerTemplates.byId[action.payload.id]
            }
            return {
                ...state,
                activeMasterBannerTemplate: activeMasterBannerTemplate
            };

        // Files Actions
        case getType(filesActions.modifyingActiveFolders):
            const activeFolders = merge({}, state.activeFolders, action.payload.activeFolders)
            return {
                ...state,
                activeFolders: {
                    ...activeFolders,
                }
            };
        case getType(filesActions.reLoadActiveFoldersAsyncAction.request):
            return {
                ...state,
                isReloadingActiveFolders: true
            }
        case getType(filesActions.reLoadActiveFoldersAsyncAction.success):
            return {
                ...state,
                isReloadingActiveFolders: false,
                activeFolders: {
                    ...state.activeFolders,
                    ...action.payload.activeFolders
                }
            }
        default:
            return state;
    }
};

function overWriteArrayCustomizer(objValue: any, srcValue: any) {
    if (isArray(objValue)) {
        return srcValue
    }
}